// Pravila sedmičnog rasporeda, zajednička za onboarding, postavke i server
// (setAvailabilitySchema). Čist modul, ide i u klijentski bundle.

export interface TimeSegment {
  startTime: string;
  endTime: string;
}

function toMinutes(t: string): number {
  const parts = t.split(":");
  return Number(parts[0]) * 60 + Number(parts[1]);
}

/** Returns an error message, or null if the segments of one day are valid. */
export function validateDaySegments(segments: TimeSegment[]): string | null {
  for (const s of segments) {
    if (toMinutes(s.startTime) >= toMinutes(s.endTime)) {
      return "Početak mora biti prije kraja.";
    }
  }
  const sorted = [...segments].sort((a, b) => toMinutes(a.startTime) - toMinutes(b.startTime));
  for (let i = 1; i < sorted.length; i++) {
    const cur = sorted[i]!;
    const prev = sorted[i - 1]!;
    if (toMinutes(cur.startTime) < toMinutes(prev.endTime)) {
      return "Periodi se ne smiju preklapati.";
    }
  }
  return null;
}

/** Redoslijed dana kako ih korisnik vidi (ponedjeljak prvi); vrijednost je dayOfWeek u bazi. */
const WEEK_ORDER: Array<[number, string]> = [
  [1, "Ponedjeljak"],
  [2, "Utorak"],
  [3, "Srijeda"],
  [4, "Četvrtak"],
  [5, "Petak"],
  [6, "Subota"],
  [0, "Nedjelja"],
];

/**
 * Cijeli sedmični raspored: po danu početak prije kraja i bez preklapanja.
 * Poruka imenuje dan, npr. "Utorak: Periodi se ne smiju preklapati."
 */
export function validateWeeklySchedule(entries: Array<TimeSegment & { dayOfWeek: number }>): string | null {
  for (const [day, label] of WEEK_ORDER) {
    const error = validateDaySegments(entries.filter((e) => e.dayOfWeek === day));
    if (error) return `${label}: ${error}`;
  }
  return null;
}
